<template>
  <div class="head_box">
    <a class="accesskey accesskey_go" href="javascript:void(0);" title="跳到中間主要內容區"
      onclick="document.getElementById('accesskey_c').scrollIntoView();">
      跳到中間主要內容區
    </a>
    <a accesskey="u" class="accesskey" id="accesskey_u" href="javascript:void(0);" title="上方區塊"
      onclick="document.getElementById('app').scrollIntoView();">
      :::
    </a>
    <div class="container">
      <div class="box">
        <div class="logo">
          <h1><img src="img/logo.png" alt="" /></h1>
        </div>
        <div class="menu">
          <div class="link_box" v-if="isLoggedIn">
            <button class="link head-btn" @click="gotoProfile">Profile</button>
            <button class="link head-btn" @click="handleLogout">Log out</button>
            <!-- <button class="link language_link">
              <svg
                id="icon_language"
                width="28.136"
                height="28.136"
                viewBox="0 0 28.136 28.136"
              >
                <path
                  id="_5"
                  data-name="5"
                  d="M175.261,452l.141,1.131a2.493,2.493,0,0,0,1.425,1.915L179.6,452Z"
                  transform="translate(-165.63 -427.161)"
                  fill="#570e64"
                />
                <path
                  id="_4"
                  data-name="4"
                  d="M381.374,257a8.614,8.614,0,0,0,1.353,2.389A8.7,8.7,0,0,0,384.135,257Z"
                  transform="translate(-360.417 -242.877)"
                  fill="#570e64"
                />
                <path
                  id="_3"
                  data-name="3"
                  d="M121.305,137h-.353l-.659,3.3h1.671Z"
                  transform="translate(-113.683 -129.472)"
                  fill="#570e64"
                />
                <path
                  id="_2"
                  data-name="2"
                  d="M254.991,91H244.754l2.134,17.128a2.559,2.559,0,0,1-.611,1.876l-3.615,4.131h12.328a2.476,2.476,0,0,0,2.473-2.473V93.528A2.523,2.523,0,0,0,254.991,91Zm0,9.122h-.22a10.46,10.46,0,0,1-1.986,3.61c.606.554,1.253,1.008,1.9,1.516a.824.824,0,1,1-1.03,1.286c-.7-.552-1.356-1.014-2.013-1.617-.657.6-1.258,1.065-1.958,1.617a.824.824,0,0,1-1.03-1.286c.644-.509,1.236-.963,1.842-1.516a10.4,10.4,0,0,1-1.931-3.61h-.22a.824.824,0,1,1,0-1.649h2.473v-.824a.824.824,0,0,1,1.649,0v.824h2.528a.824.824,0,0,1,0,1.649Z"
                  transform="translate(-229.328 -85.999)"
                  fill="#570e64"
                />
                <path
                  id="_1"
                  data-name="1"
                  d="M13.417,2.166A2.476,2.476,0,0,0,10.964,0H2.473A2.476,2.476,0,0,0,0,2.473V20.717A2.476,2.476,0,0,0,2.473,23.19h13c.24-.275.442-.447.451-.806C15.925,22.294,13.429,2.255,13.417,2.166ZM10.108,15.755a.824.824,0,0,1-.97-.646l-.527-2.635H6.281l-.527,2.635a.824.824,0,1,1-1.616-.324L5.786,6.542a.825.825,0,0,1,.808-.663H8.3a.825.825,0,0,1,.808.663l1.649,8.243A.824.824,0,0,1,10.108,15.755Z"
                  fill="#570e64"
                />
              </svg>
              EN
            </button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="border_bg"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "Header",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  methods: {
    ...mapActions(['logout']),
    gotoProfile() {
      if (this.$route.path !== "/Profile") {
        this.$router.push("/Profile").then(() => {
          window.scrollTo(0, 0); // 滾到最上面
        });
      }
    },
    handleLogout() {
      this.logout();
      this.$router.push('/');
    },
  },
};
</script>